var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 1.66797H3.98438C3.73825 1.66797 3.54492 1.84841 3.54492 2.07812V13.5898C3.54492 13.8195 3.73825 14 3.98438 14H12.7734C13.0196 14 13.2129 13.8195 13.2129 13.5898V2.07812C13.2129 1.84841 13.0196 1.66797 12.7734 1.66797Z",
    fill: "#3A416F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2129 2.07812V13.5898C13.2129 13.8195 13.0196 14 12.7734 14H6.62109V1.66797H12.7734C13.0196 1.66797 13.2129 1.84841 13.2129 2.07812Z",
    fill: "#3A416F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0156 0H2.22656C1.98044 0 1.78711 0.180441 1.78711 0.410156V11.9492C1.78711 12.1789 1.98044 12.3594 2.22656 12.3594H11.0156C11.2617 12.3594 11.4551 12.1789 11.4551 11.9492V0.410156C11.4551 0.180441 11.2617 0 11.0156 0Z",
    fill: "#B9BCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4551 0.410156V11.9492C11.4551 12.1789 11.2617 12.3594 11.0156 12.3594H6.62109V0H11.0156C11.2617 0 11.4551 0.180441 11.4551 0.410156Z",
    fill: "#B9BCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06055 2.89844C7.06055 3.1281 6.86722 3.30859 6.62109 3.30859H3.98438C3.73825 3.30859 3.54492 3.1281 3.54492 2.89844C3.54492 2.66872 3.73825 2.48828 3.98438 2.48828H6.62109C6.86722 2.48828 7.06055 2.66872 7.06055 2.89844Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69727 4.53906C9.69727 4.76872 9.50394 4.94922 9.25781 4.94922H3.98438C3.73825 4.94922 3.54492 4.76872 3.54492 4.53906C3.54492 4.30935 3.73825 4.12891 3.98438 4.12891H9.25781C9.50394 4.12891 9.69727 4.30935 9.69727 4.53906Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69727 6.17969C9.69727 6.40935 9.50394 6.58984 9.25781 6.58984H3.98438C3.73825 6.58984 3.54492 6.40935 3.54492 6.17969C3.54492 5.94997 3.73825 5.76953 3.98438 5.76953H9.25781C9.50394 5.76953 9.69727 5.94997 9.69727 6.17969Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69727 7.82031C9.69727 8.04997 9.50394 8.23047 9.25781 8.23047H3.98438C3.73825 8.23047 3.54492 8.04997 3.54492 7.82031C3.54492 7.5906 3.73825 7.41016 3.98438 7.41016H9.25781C9.50394 7.41016 9.69727 7.5906 9.69727 7.82031Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25781 9.87109H7.5C7.2571 9.87109 7.06055 9.68764 7.06055 9.46094C7.06055 9.23423 7.2571 9.05078 7.5 9.05078H9.25781C9.50071 9.05078 9.69727 9.23423 9.69727 9.46094C9.69727 9.68764 9.50071 9.87109 9.25781 9.87109Z",
    fill: "#B9BCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62109 3.30859V2.48828C6.86722 2.48828 7.06055 2.66872 7.06055 2.89844C7.06055 3.1281 6.86722 3.30859 6.62109 3.30859Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69727 7.82031C9.69727 8.04997 9.50394 8.23047 9.25781 8.23047H6.62109V7.41016H9.25781C9.50394 7.41016 9.69727 7.5906 9.69727 7.82031Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69727 6.17969C9.69727 6.40935 9.50394 6.58984 9.25781 6.58984H6.62109V5.76953H9.25781C9.50394 5.76953 9.69727 5.94997 9.69727 6.17969Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25781 4.94922H6.62109V4.12891H9.25781C9.50394 4.12891 9.69727 4.30935 9.69727 4.53906C9.69727 4.76872 9.50394 4.94922 9.25781 4.94922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainReport);
export default __webpack_public_path__ + "static/media/main-report.376d24e42828cfb9f5eaa89e2c147620.svg";
export { ForwardRef as ReactComponent };